import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import { useFormikContext } from 'formik';
import React from 'react';
import { PersonalDocumentType } from 'v2/components/Pages/AddBankAccount/Stepper/form';

import type { INewAccount } from 'v2/interfaces/financial';

import { useStyles } from '../styles';

interface IProps {
  activeStep: number;
  hasVideo?: boolean;
  docType: string;
  onBack: () => void;
  onNext: () => void;
}

const NavButtons = ({ activeStep, hasVideo = true, docType, onBack, onNext }: IProps) => {
  const classes = useStyles();
  const { dirty, isValid, values, isSubmitting, handleSubmit, setSubmitting, errors } = useFormikContext<INewAccount>();
  const { imgsIds, bank_id, operation_id } = values;

  const onSubmit = () => {
    setSubmitting(true);
    handleSubmit();
  };

  const tooltipMessage = Object.values(errors)[0] || '';
  const caixaEconomicaId = '104';

  return (
    <>
      {activeStep > 0 && (
        <Button color='default' onClick={onBack}>
          Voltar
        </Button>
      )}
      <Tooltip title={tooltipMessage} placement='top'>
        <Grid className={classes.nextBtn}>
          {activeStep === 0 && (
            <Button
              variant='contained'
              color='primary'
              onClick={onNext}
              disabled={!dirty || !isValid || (bank_id === caixaEconomicaId && operation_id === 'not-selected')}
              className={classes.nextBtn}
            >
              Próximo
            </Button>
          )}
          {activeStep === 1 && (
            <Button
              variant='contained'
              color='primary'
              onClick={onNext}
              disabled={
                (docType === PersonalDocumentType.CNH ? !imgsIds.imgDocCNH : !imgsIds.imgDocRG || !imgsIds.imgDocCPF) ||
                (hasVideo && !imgsIds.videoDoc) ||
                isSubmitting
              }
            >
              {isSubmitting ? 'Enviando...' : 'Próximo'} {isSubmitting && <CircularProgress size={20} style={{ marginLeft: 10 }} />}
            </Button>
          )}
          {activeStep === 2 && (
            <Button
              variant='contained'
              color='primary'
              onClick={onNext}
              disabled={!imgsIds.imgBankReceipt || isSubmitting}
              className={classes.nextBtn}
            >
              {isSubmitting ? 'Enviando...' : 'Próximo'} {isSubmitting && <CircularProgress size={20} style={{ marginLeft: 10 }} />}
            </Button>
          )}
          {activeStep === 3 && (
            <Button variant='contained' color='secondary' onClick={onSubmit} disabled={isSubmitting}>
              {isSubmitting ? 'Enviando... ' : 'Finalizar'} {isSubmitting && <CircularProgress size={20} style={{ marginLeft: 10 }} />}
            </Button>
          )}
        </Grid>
      </Tooltip>
    </>
  );
};

export default NavButtons;
